// extracted by mini-css-extract-plugin
export default {"form":"TaskForm_form__zGw36","input":"TaskForm_input__lNQP-","btn":"TaskForm_btn__-RJF0"};